// src/pages/ArticlesIndex.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ARTICLES } from '../content/articles.mjs';
import { usePageMeta } from '../lib/seo';

const ArticlesIndex = () => {
  usePageMeta({
    title: 'Articles',
    description:
      'Plain-language articles on medicines, pharmaceutical regulation and pricing — from SAHPRA registration and Single Exit Prices to how medicines are approved worldwide.',
    path: '/articles/',
  });

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-blue-800 mb-2">Articles</h1>
      <p className="text-gray-600 mb-8">
        Plain-language reference articles on medicines, regulation and pricing — in South Africa and worldwide.
      </p>
      <div className="space-y-6">
        {ARTICLES.map((article) => (
          <article key={article.slug} className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-semibold text-blue-800 mb-1">
              <Link to={`/articles/${article.slug}/`} className="hover:underline">
                {article.title}
              </Link>
            </h2>
            <p className="text-sm text-gray-400 mb-2">
              {article.datePublished}
              {article.tags && article.tags.length > 0 && <> · {article.tags.join(' · ')}</>}
            </p>
            <p className="text-gray-600">{article.description}</p>
            <Link
              to={`/articles/${article.slug}/`}
              className="inline-block mt-3 text-sm font-medium text-blue-600 hover:underline"
            >
              Read article →
            </Link>
          </article>
        ))}
      </div>
    </div>
  );
};

export default ArticlesIndex;
